<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <v-form @submit.prevent="handleSubmit">
      <v-card>
        <v-card-title>
          Alterar complexidade
          <v-spacer></v-spacer>
          <v-btn @click="close()" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-alert v-if="lead.insurer_complexity" type="info" text dense>
            Classificação da companhia:
            {{ lead.insurer_complexity.name }}
          </v-alert>

          <v-radio-group v-model="form.complexity_id" label="Complexidade">
            <v-radio
              v-for="item in complexities"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></v-radio>
          </v-radio-group>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="close()" text>Cancelar</v-btn>
          <v-btn type="submit" color="primary" :loading="submitting">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { showCategory } from "@/services/form_options";
import { updateComplexity } from "@/services/lead";

export default {
  mixins: [],

  components: {},

  props: {
    lead: Object,
  },

  data() {
    return {
      dialog: false,
      form: {},
      complexities: [],
      loading: false,
      submitting: false,
    };
  },

  methods: {
    open() {
      this.dialog = true;
      this.loadItems();
      this.form = {
        complexity_id: this.lead.complexity_id,
      };
    },
    close() {
      this.dialog = false;
    },
    async handleSubmit() {
      this.submitting = true;
      try {
        await updateComplexity(this.lead.id, this.form);
        this.$store.commit("sendMessage", {
          text: "Salvo",
        });
        this.$store.dispatch("refreshLead");
        this.close();
      } finally {
        this.submitting = false;
      }
    },
    getCategoryCode() {
      if (this.lead.lead_type === 1) {
        return "MR_SERVICE_COMPLEXITY";
      }

      if (this.lead.lead_type === 2) {
        return "RE_SERVICE_COMPLEXITY";
      }
    },
    async loadItems() {
      this.loading = true;

      try {
        const { data } = await showCategory(this.getCategoryCode());
        this.complexities = data.data.options;
      } finally {
        this.loading = false;
      }
    },
  },

  computed: {},
};
</script>
